import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const GraphIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={getDefaultHeight(svgProps, 24)}
      strokeWidth="1.5"
      {...svgProps}
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="5.25" cy="11.25" r="3.75" />
      <circle cx="18.75" cy="6" r="3.75" />
      <circle cx="18.75" cy="18" r="3.75" />
      <path d="M8.746 9.891l6.508-2.531M8.605 12.928l6.79 3.395" />
    </SVG>
  );
};
